import img1 from '../images/box-item/auctions-1.jpg';
import img2 from '../images/box-item/auctions-4.jpg';
import img3 from '../images/box-item/auctions-3.jpg';
import img4 from '../images/box-item/auctions-2.jpg';

import img5 from '../images/box-item/auctions-5.jpg';
import img6 from '../images/box-item/auctions-6.jpg';
import img7 from '../images/box-item/auctions-3.jpg';
import img8 from '../images/box-item/auctions-7.jpg';
import img9 from '../images/box-item/auctions-8.jpg';
import img10 from '../images/box-item/auctions-9.jpg';
import img11 from '../images/box-item/auctions-10.jpg';
import img12 from '../images/box-item/auctions-11.jpg';


import imgauthor1 from '../images/avatar/avt-01.png';

import icon1 from '../images/icon/author-check.svg';
import icon2 from '../images/icon/icon-diamond.svg';


const dataLiveaution = [
    {
        id: 1,
        img: img1,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        icon1 : icon1,
        icon2 : icon2,
        titlecountdown: 'Ending Time -',
    },
    {
        id: 2,
        img: img2,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 3,
        img: img3,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 4,
        img: img4,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },

    {
        id: 5,
        img: img5,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        icon1 : icon1,
        icon2 : icon2,
        titlecountdown: 'Ending Time -',
    },
    {
        id: 6,
        img: img6,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 7,
        img: img7,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 8,
        img: img8,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 9,
        img: img9,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },

    {
        id: 10,
        img: img10,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        icon1 : icon1,
        icon2 : icon2,
        titlecountdown: 'Ending Time -',
    },
    {
        id: 11,
        img: img9,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 12,
        img: img10,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 13,
        img: img11,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        icon1 : icon1,
        icon2 : icon2,
        titlecountdown: 'Ending Time -',
    },
    {
        id: 14,
        img: img12,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 15,
        img: img7,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },
    {
        id: 16,
        img: img8,
        tags: '6 in stock',
        title: 'Axtronic Electronics VS-10',
        imgauthor: imgauthor1,
        author: 'Themesflat',
        date: '@ 3d Models',
        titleprice: '2.39 ETH',
        btn: 'Place Bid',
        titlecountdown: 'Ending Time -',
        icon1 : icon1,
        icon2 : icon2,
    },

]

export default dataLiveaution;